// extracted by mini-css-extract-plugin
export default {"footer":"JoinOurCommunity_footer__9E9wh"};